const translations = {
  es: {
    Cerrar: " Cerrar",
    GestionPedidos: "Gestión de Pedidos",
    HistoricoPedidos: "Histórico de Pedidos",
    GestionContenedores: "Gestión Contenedores",
    HistoricoContenedores: "Histórico Contenedores",
    AsociarPedidoContenedor: "Asociar Pedido",
    BotonEditarContenedor: "Editar",
    BotonEliminarContenedor: "Eliminar",
    BotonDespacharContenedor: "Despachar",
    Acciones: "Acciones",
    searchPlaceholder: "Buscar...",
    createButton: "Crear",
    CrearContenedor: "Crear",
    editButton: "Editar",
    deleteButton: "Eliminar",
    LE_Button: "Lista de Empaque",
    errorEditPedido: "El pedido no se puede editar en este estado.",
    erroralcargarpedido: "Error al cargar pedidos. ",
    error_eliminar_le: "Error al eliminar la lista de empaque",
    error_eliminarContenedor: "Error al eliminar el contenedor",
    error_anular_pedido: "Error al anular el pedido",
    tooltip_Cargar: "Cargar",
    tooltip_Aprobar: "Aprobar",
    tooltip_Ver: "Ver",
    tooltip_Descargar: "Descargar", // [EXPERT_FIX]: Nueva traducción
    VerMercanciaContenedor: "Ver Contenedor", // [EXPERT_FIX]: Nueva traducción faltante
    tooltip_Eliminar: "Eliminar",
    dialog_mje_elim_ped: "Está seguro de eliminar el pedido?",
    mje_eliminar_contenedor: "¿Está seguro de eliminar el contenedor?",
    mje_anular_pedido: "¿Está seguro de anular el pedido?",
    aprobarlistaempaque: "Está seguro de Aprobar la lista de empaque?",
    text_Confirmacion: "Confirmación",
    accioncancelada: "Acción Cancelada",
    yesbutton: "Sí",
    nobutton: "No",
    title_error: "Error",
    erroralactualizar: "Error al actualizar",
    estadoincorrecto: "Estado incorrecto",
    pedsinlistadeempaque: "El pedido no tiene listas de Empaque",
    pedidonopuedesereditado:
      "El pedido no puede ser editado en su estado actual.",
    accionnopermitida: "Acción no permitida",
    listaaprobada: "La lista de empaque del pedido ya fue aprobada",
    pedidodebeserleok: "El pedido debe estar en estado LE_OK para ser aprobado",
    pedidosinlistaempaque: "El pedido no tiene listas de empaque asociadas",
    le_nopuedeserelim: "La lista de empaque no puede ser eliminada",
    le_actualizada: "La lista de empaque fue actualizada con éxito.",
    le_noactualizada: "No se pudo actualizar la lista de empaque.",
    preg_eliminar_le_pedido:
      "Está seguro de eliminar la lista de empaque del pedido?",
    ped_creado_borrar_le:
      "El pedido debe estar en estado CREADO; borre la Lista de empaque",
    estado_eliminar_contenedor: "El contenedor debe estar en estado CREADO",
    actualizacion_exitosa: "Actualización exitosa",
    listadeempaque_eliminada: "Lista de Empaque eliminada",
    eliminar_le:
      "La lista de empaque ha sido eliminada y el estado del pedido se ha actualizado a CREADO",
    pedidoeliminado: "Pedido eliminado",
    error_eliminar_pedido: "Error al eliminar el pedido",
    Contenedoreliminado: "Contenedor Eliminado",
    advertencia: "Advertencia",
    noDatos: "No hay datos de lista de empaque para descargar.",
    descargaExitosa: "Lista de empaque descargada con éxito.",
    erroraldescargar: "Error al descargar la lista de empaque",
    error_no_contenedor_seleccionado:
      "No se ha seleccionado ningún contenedor para despachar.",
    ContenedorDespachadoExito: "Contenedor despachado con éxito.",
    error_despacharContenedor: "Error al despachar el contenedor",
    estado_despachar_contenedor:
      "El contenedor debe estar en estado CREADO o ASIGNADO para ser despachado",
    mje_despachar_contenedor: "¿Está seguro de despachar el contenedor?",
    BillOfLadingeliminado: "BL eliminado correctamente", // [EXPERT_COMMENT]: Nueva traducción - Se añadió la traducción para el mensaje de éxito al eliminar un Bill of Lading.
    error_eliminarBillOfLading: "Error al eliminar el BL", // [EXPERT_COMMENT]: Nueva traducción - Se añadió la traducción para el mensaje de error al eliminar un Bill of Lading.
    estado_eliminar_BillOfLading:
      "El BL debe estar en estado CREADO para ser eliminado", // [EXPERT_COMMENT]: Nueva traducción - Se añadió la traducción para el mensaje de error de estado al eliminar un Bill of Lading.
    CrearBillOfLading: "Crear Nuevo BL",
    BotonEditarBillOfLading: "Editar BL",
    BotonEliminarBillOfLading: "Eliminar BL",
    GestionBillOfLading: "Gestion Bill of Lading",
    anularButton: "Anular",
    dialog_mje_anular_ped: "¿Está seguro de anular el pedido?",
    columns: [
      { field: "idpedido", header: "ID", width: "45px" },
      { field: "sNombreCliente", header: "Cliente", width: "300px" },
      { field: "sNombreEstadoPedido", header: "Estado Pedido", width: "130px" },
      {
        field: "fecha_pedido",
        header: "Fecha Pedido",
        width: "150px",
        body: (row) =>
          row.fecha_pedido
            ? new Date(row.fecha_pedido).toLocaleDateString()
            : "",
      },

      { field: "destino", header: "Destino", width: "110px" },
      {
        field: "iCantidad_Cajas_P",
        header: "Cajas Pedido",
        width: "90px",
        body: (row) =>
          row.iCantidad_Cajas_P
            ? Math.round(parseFloat(row.iCantidad_Cajas_P))
            : 0,
      },
      {
        field: "peso_bruto",
        header: "Peso Bruto",
        width: "90px",
        body: (row) =>
          row.peso_bruto ? parseFloat(row.peso_bruto).toFixed(2) : "0.00",
      },
      {
        field: "dMetrosCubicos",
        header: "CBM",
        width: "80px",
        body: (row) =>
          row.dMetrosCubicos
            ? parseFloat(row.dMetrosCubicos).toFixed(2)
            : "0.00",
      },
      { field: "sMarca", header: "Marca", width: "100px" },
      { field: "sTM", header: "TM", width: "70px" },
      {
        field: "fecha_llegada_a_bodega_estimada",
        header: "Fecha Estimada",
        width: "110px",
        body: (row) =>
          row.fecha_llegada_a_bodega_estimada
            ? new Date(row.fecha_llegada_a_bodega_estimada).toLocaleDateString()
            : "",
      },
      {
        field: "fecha_llegada_a_bodega",
        header: "Llega a Bodega",
        width: "110px",
        body: (row) =>
          row.fecha_llegada_a_bodega
            ? new Date(row.fecha_llegada_a_bodega).toLocaleDateString()
            : "",
      },

      { field: "sRegistroIngreso", header: "Reg Ing", width: "100px" },
    ],
    columnsHistorico: [
      { field: "idpedido", header: "ID" },
      { field: "sNombreCliente", header: "Cliente" },
      { field: "sNombreEstadoPedido", header: "Estado" },
      {
        field: "fecha_pedido",
        header: "Fecha",
        body: (row) =>
          row.fecha_pedido
            ? new Date(row.fecha_pedido).toLocaleDateString()
            : "",
      },

      { field: "destino", header: "Destino" },
      {
        field: "iCantidad_Cajas_P",
        header: "Cajas",
        body: (row) =>
          row.iCantidad_Cajas_P
            ? Math.round(parseFloat(row.iCantidad_Cajas_P))
            : 0,
      },
      {
        field: "peso_bruto",
        header: "Peso Bruto",
        body: (row) =>
          row.peso_bruto ? parseFloat(row.peso_bruto).toFixed(2) : "0.00",
      },
      {
        field: "dMetrosCubicos",
        header: "CBM",
        body: (row) =>
          row.dMetrosCubicos
            ? parseFloat(row.dMetrosCubicos).toFixed(2)
            : "0.00",
      },
      { field: "sMarca", header: "Marca" },
      { field: "sTM", header: "TM" },
      {
        field: "fecha_llegada_a_bodega",
        header: "Llega a Bodega",
        body: (row) =>
          row.fecha_llegada_a_bodega
            ? new Date(row.fecha_llegada_a_bodega).toLocaleDateString()
            : "",
      },

      { field: "sRegistroIngreso", header: "Reg Ing" },
    ],
    /* columnsContenedores: [
      { field: "IdContenedor", header: "Id" },
      { field: "sNroContenedor", header: "Nro" },
      { field: "sNombreEstadoContenedor", header: "Estado" },
      { field: "iMedida", header: "Medida" },
      { field: "sSerial", header: "Serial" },
      { field: "iCantidadCajas", header: "Cant. de Cajas" },
      { field: "dFechaDespacho", header: "Fecha de Despacho", body: (row) => new Date(row.dFechaDespacho).toLocaleDateString() },
      { field: "dPesoNeto", header: "Peso Neto" },
      { field: "dPesoBruto", header: "Peso Bruto" },
    ], */
    columnsContenedores: [
      { field: "IdContenedor", header: "Id" },
      { field: "sNroContenedor", header: "Nro" },
      { field: "sNombreEstadoContenedor", header: "Estado" },
      { field: "iMedida", header: "Medida" },
      { field: "sSerial", header: "Serial" },
      { field: "iCantidadCajas", header: "Cant. de Cajas" },
      //  { field: 'dFechaDespacho', header: 'Fecha de Despacho', body: row => new Date(row.dFechaDespacho).toLocaleDateString() },
      { field: "dPesoBruto", header: "Peso Bruto" },
      { field: "dMetrosCubicos", header: "CMB" },
    ],
    columnsHistoricoContenedores: [
      { field: "IdContenedor", header: "Id" },
      { field: "sNroContenedor", header: "Nro" },
      { field: "sNombreEstadoContenedor", header: "Estado" },
      { field: "iMedida", header: "Medida" },
      { field: "sSerial", header: "Serial" },
      { field: "iCantidadCajas", header: "Cant. de Cajas" },
      //  { field: 'dFechaDespacho', header: 'Fecha de Despacho', body: row => new Date(row.dFechaDespacho).toLocaleDateString() },
      { field: "dPesoBruto", header: "Peso Bruto" },
      { field: "dMetrosCubicos", header: "CMB" },
    ],
    columnsBL: [
      { field: "id_bl", header: "ID BL" }, // [EXPERT_COMMENT]: Movimiento de columna - Se mueve al principio del array.
      { field: "nroBL", header: "Numero BL" },
      { field: "NombreEstado", header: "Estado BL" },
      {
        field: "FechaEmision",
        header: "Fecha Emision",
        body: (row) =>
          row.FechaEmision
            ? new Date(row.FechaEmision).toLocaleDateString()
            : "",
      }, // [EXPERT_COMMENT]: Corrección de campo - Se cambió `dFechaEmision` a `FechaEmision` para coincidir con el backend.
      { field: "Importador", header: "Importador" },
      { field: "Shipper", header: "Shipper" },
      { field: "NombreConsignee", header: "Consignee" },
      { field: "NombreNotifyParty", header: "Notify" },
      { field: "NombreNaviera", header: "Naviera" },
      { field: "NombrePuertoDestino", header: "Puerto Destino" }, // [EXPERT_COMMENT]: Corrección de campo - Se cambió `NombrePuertoDestinoDisplay` a `NombrePuertoDestino` para coincidir con la propiedad devuelta por el backend.
    ],
  },
  en: {
    GestionPedidos: "Order Management",
    GestionContenedores: "Container Management",
    AsociarPedidoContenedor: "Link Order",
    Acciones: "Actions",
    searchPlaceholder: "Search...",
    createButton: "Create Order",
    CrearContenedor: "Create Container",
    editButton: "Edit Order",
    deleteButton: "Delete Order",
    LE_Button: "Packing List",
    errorEditPedido: "The order cannot be edited in this state.",
    erroralcargarpedido: "Error loading orders.",
    error_eliminar_le: "Error deleting the packing list",
    error_eliminarContenedor: "Error deleting the container",
    tooltip_Cargar: "Upload",
    tooltip_Aprobar: "Approve",
    tooltip_Ver: "View",
    tooltip_Descargar: "Download", // [EXPERT_FIX]: Nueva traducción EN
    VerMercanciaContenedor: "View Container", // [EXPERT_FIX]: Nueva traducción faltante EN
    tooltip_Eliminar: "Delete",
    dialog_mje_elim_ped: "Are you sure you want to delete the order?",
    mje_eliminar_contenedor: "Are you sure you want to delete the container?",
    aprobarlistaempaque: "Are you sure you want to approve the packing list?",
    text_Confirmacion: "Confirmation",
    accioncancelada: "Action Cancelled",
    yesbutton: "Yes",
    nobutton: "No",
    title_error: "Error",
    erroralactualizar: "Error updating",
    estadoincorrecto: "Incorrect state",
    pedsinlistadeempaque: "The order has no packing lists",
    pedidonopuedesereditado: "The order cannot be edited in its current state.",
    accionnopermitida: "Action not allowed",
    listaaprobada: "The orders packing list has already been approved",
    pedidodebeserleok: "The order must be in LE_OK status to be approved",
    pedidosinlistaempaque: "The order has no associated packing lists",
    le_nopuedeserelim: "The packing list cannot be deleted",
    le_actualizada: "The packing list was successfully updated",
    le_noactualizada: "The packing list could not be updated.",
    preg_eliminar_le_pedido:
      "Are you sure you want to delete the orders packing list?",
    ped_creado_borrar_le:
      "The order must be in CREATED status; delete the packing list",
    estado_eliminar_contenedor: "The container must be in CREADO status",
    actualizacion_exitosa: "Update successful",
    listadeempaque_eliminada: "Packing list deleted",
    eliminar_le:
      "The packing list has been deleted, and the order status has been updated to CREADO",
    pedidoeliminado: "Order deleted",
    error_eliminar_pedido: "Error deleting the order",
    Contenedoreliminado: "Container Deleted",
    error_no_contenedor_seleccionado: "No container selected for dispatch.",
    ContenedorDespachadoExito: "Container dispatched successfully.",
    advertencia: "Warning",
    noDatos: "No packing list data to download.",
    descargaExitosa: "Packing list downloaded successfully.",
    erroraldescargar: "Error downloading packing list",
    error_despacharContenedor: "Error dispatching container",
    estado_despachar_contenedor:
      "The container must be in CREATED or ASSIGNED status to be dispatched",
    mje_despachar_contenedor:
      "Are you sure you want to dispatch the container?",
    columns: [
      { field: "idpedido", header: "ID" },
      { field: "sNombreCliente", header: "Client" },
      { field: "sNombreEstadoPedido", header: "Order Status", width: "130px" },
      {
        field: "fecha_pedido",
        header: "Order Date",
        body: (row) =>
          row.fecha_pedido
            ? new Date(row.fecha_pedido).toLocaleDateString()
            : "",
      },

      { field: "destino", header: "Destination" },
      { field: "iCantidad_Cajas_P", header: "Order Box Quantity" },

      {
        field: "peso_bruto",
        header: "Gross Weight",
        body: (row) =>
          row.peso_bruto
            ? parseFloat(row.peso_bruto).toLocaleString("en-US", {
                minimumFractionDigits: 1,
              })
            : "0.0",
      },
      {
        field: "dMetrosCubicos",
        header: "CBM",
        body: (row) =>
          row.dMetrosCubicos
            ? parseFloat(row.dMetrosCubicos).toLocaleString("en-US", {
                minimumFractionDigits: 1,
              })
            : "0.0",
      },
      { field: "sMarca", header: "Brand" },
      { field: "sTM", header: "TM" },
      {
        field: "fecha_llegada_a_bodega_estimada",
        header: "Estimated Receiving",
        body: (row) =>
          row.fecha_llegada_a_bodega_estimada
            ? new Date(row.fecha_llegada_a_bodega_estimada).toLocaleDateString()
            : "",
      },
      {
        field: "fecha_llegada_a_bodega",
        header: "Receiving Date",
        body: (row) =>
          row.fecha_llegada_a_bodega
            ? new Date(row.fecha_llegada_a_bodega).toLocaleDateString()
            : "",
      },
      { field: "sRegistroIngreso", header: "Access Log" },
    ],
    columnsContenedores: [
      { field: "IdContenedor", header: "ID" },
      { field: "sNroContenedor", header: "Number" },
      { field: "sNombreEstadoContenedor", header: "Status" },
      { field: "iMedida", header: "Measurement" },
      { field: "sSerial", header: "Serial" },
      { field: "iCantidadCajas", header: "Num. of Boxes" },
      {
        field: "dFechaDespacho",
        header: "Dispatch Date",
        body: (row) => new Date(row.dFechaDespacho).toLocaleDateString(),
      },
      { field: "dPesoNeto", header: "Net Weight" },
      { field: "dPesoBruto", header: "Gross Weight" },
      // { field: 'mDescripcion', header: 'Description' },
    ],
    // [EXPERT_COMMENT]: Añadir definición de columnas para Bill of Lading - Corrige TypeError al acceder a 'columnsBL' que estaba indefinido.
    columnsBL: [
      { field: "id_bl", header: "BL ID" }, // [EXPERT_COMMENT]: Movimiento de columna - Se mueve al principio del array.
      { field: "nroBL", header: "Number BL" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreEstado", header: "BL Status" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      {
        field: "FechaEmision",
        header: "Issue Date",
        body: (row) =>
          row.FechaEmision
            ? new Date(row.FechaEmision).toLocaleDateString()
            : "",
      }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "Shipper", header: "Shipper" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreConsignee", header: "Consignee" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreNotifyParty", header: "Notify" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreNaviera", header: "Shipping Line" }, // [EXPERT_COMMENT]: Mantiene el campo existente.
      { field: "NombrePuertoDestino", header: "Destination Port" }, // [EXPERT_COMMENT]: Corrección de campo - Se cambió `NombrePuertoDestinoDisplay` a `NombrePuertoDestino` para coincidir con la propiedad devuelta por el backend.
    ],
  },
  zh: {
    GestionPedidos: "管理订单",
    GestionContenedores: "集装箱管理",
    AsociarPedidoContenedor: "关联订单",
    Acciones: "操作",
    searchPlaceholder: "搜索...",
    createButton: "创建订单",
    CrearContenedor: "创建集装箱",
    editButton: "编辑订单",
    deleteButton: "删除订单",
    LE_Button: "上传装箱单",
    errorEditPedido: "300-当前状态下订单无法编辑。",
    erroralcargarpedido: "301-加载订单时出错。 ",
    error_eliminar_le: "304-删除包装清单时出错",
    error_eliminarContenedor: "删除集装箱时出错",
    tooltip_Cargar: "上传",
    tooltip_Aprobar: "批准",
    tooltip_Ver: "查看",
    tooltip_Descargar: "下载", // [EXPERT_FIX]: Nueva traducción ZH
    VerMercanciaContenedor: "查看集装箱", // [EXPERT_FIX]: Nueva traducción faltante ZH
    tooltip_Eliminar: "删除",
    dialog_mje_elim_ped: "您确定要删除订单吗",
    mje_eliminar_contenedor: "您确定要删除集装箱吗？",
    aprobarlistaempaque: "您确定要批准包装清单吗",
    text_Confirmacion: "确认",
    accioncancelada: "操作已取消",
    yesbutton: "是",
    nobutton: "否",
    title_error: "错误",
    erroralactualizar: "302-更新时出错",
    estadoincorrecto: "303-状态不正确",
    pedsinlistadeempaque: "订单没有包装清单",
    pedidonopuedesereditado: "订单在当前状态下无法编辑。",
    accionnopermitida: "操作不允许",
    listaaprobada: "订单的包装清单已批准",
    pedidodebeserleok: "订单必须处于 LE_OK 状态才能批准",
    pedidosinlistaempaque: "订单没有关联的包装清单",
    le_nopuedeserelim: "包装清单无法删除",
    le_actualizada: "包装清单已成功更新",
    le_noactualizada: "无法更新包装清单",
    preg_eliminar_le_pedido: "您确定要删除订单的包装清单吗？",
    ped_creado_borrar_le: "订单必须处于创建状态；请删除包装清单",
    estado_eliminar_contenedor: "集装箱必须处于 CREADO 状态",
    actualizacion_exitosa: "更新成功",
    listadeempaque_eliminada: "包装清单已删除",
    eliminar_le: "包装清单已删除，订单状态已更新为 CREADO",
    pedidoeliminado: "订单已删除",
    error_eliminar_pedido: "删除订单时出错",
    Contenedoreliminado: "集装箱已删除",
    error_no_contenedor_seleccionado: "未选择任何集装箱进行调度。",
    ContenedorDespachadoExito: "集装箱已成功调度。",
    advertencia: "警告",
    noDatos: "没有可下载的装箱单数据。",
    descargaExitosa: "装箱单下载成功。",
    erroraldescargar: "下载装箱单时出错",
    error_despacharContenedor: "调度集装箱时出错",
    estado_despachar_contenedor:
      "集装箱必须处于 CREATED 或 ASSIGNED 状态才能调度",
    mje_despachar_contenedor: "您确定要调度集装箱吗？",
    columns: [
      { field: "idpedido", header: "编号" },
      { field: "sNombreCliente", header: "客户名称" },
      { field: "sNombreEstadoPedido", header: "订单状态", width: "130px" },
      {
        field: "fecha_pedido",
        header: "订单日期",
        body: (row) =>
          row.fecha_pedido
            ? new Date(row.fecha_pedido).toLocaleDateString()
            : "",
      },

      { field: "destino", header: "目的地" },
      { field: "iCantidad_Cajas_P", header: "订单箱子数量" },

      {
        field: "peso_bruto",
        header: "毛重",
        body: (row) =>
          row.peso_bruto
            ? parseFloat(row.peso_bruto).toLocaleString("zh-CN", {
                minimumFractionDigits: 1,
              })
            : "0.0",
      },
      {
        field: "dMetrosCubicos",
        header: "总体积",
        body: (row) =>
          row.dMetrosCubicos
            ? parseFloat(row.dMetrosCubicos).toLocaleString("zh-CN", {
                minimumFractionDigits: 1,
              })
            : "0.0",
      },
      { field: "sMarca", header: "品牌" },
      { field: "sTM", header: "TM" },
      {
        field: "fecha_llegada_a_bodega_estimada",
        header: "预计到达",
        body: (row) =>
          row.fecha_llegada_a_bodega_estimada
            ? new Date(row.fecha_llegada_a_bodega_estimada).toLocaleDateString()
            : "",
      },

      {
        field: "fecha_llegada_a_bodega",
        header: "到仓日期",
        body: (row) =>
          row.fecha_llegada_a_bodega
            ? new Date(row.fecha_llegada_a_bodega).toLocaleDateString()
            : "",
      },

      { field: "sRegistroIngreso", header: "入库记录" },
    ],
    columnsContenedores: [
      { field: "IdContenedor", header: "集装箱 ID" },
      { field: "sNroContenedor", header: "集装箱编号" },
      { field: "sNombreEstadoContenedor", header: "集装箱状态" },
      { field: "iMedida", header: "尺寸" },
      { field: "sSerial", header: "序列号" },
      { field: "iCantidadCajas", header: "箱子数量" },
      {
        field: "dFechaDespacho",
        header: "发货日期",
        body: (row) => new Date(row.dFechaDespacho).toLocaleDateString(),
      },
      { field: "dPesoNeto", header: "净重" },
      { field: "dPesoBruto", header: "毛重" },
      //  { field: 'mDescripcion', header: '描述' },
    ],
    // [EXPERT_COMMENT]: Añadir definición de columnas para Bill of Lading - Corrige TypeError al acceder a 'columnsBL' que estaba indefinido.
    columnsBL: [
      { field: "id_bl", header: "提单编号" }, // [EXPERT_COMMENT]: Movimiento de columna - Se mueve al principio del array.
      { field: "nroBL", header: "提单号码" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreEstado", header: "提单状态" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      {
        field: "FechaEmision",
        header: "签发日期",
        body: (row) =>
          row.FechaEmision
            ? new Date(row.FechaEmision).toLocaleDateString()
            : "",
      }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "Shipper", header: "发货人" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreConsignee", header: "收货人" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreNotifyParty", header: "通知方" }, // [EXPERT_COMMENT]: Corrección de campo - Coincide con el alias del backend.
      { field: "NombreNaviera", header: "船公司" }, // [EXPERT_COMMENT]: Mantiene el campo existente.
      { field: "NombrePuertoDestino", header: "目的港" }, // [EXPERT_COMMENT]: Corrección de campo - Se cambió `NombrePuertoDestinoDisplay` a `NombrePuertoDestino` a `NombrePuertoDestino` para coincidir con la propiedad devuelta por el backend.
    ],
  },
};

export const Traductor = (lang) => translations[lang] || translations.es;
